import React from "react";
import CarList from "../carList/carList.component";

const CarSelection = ({ second }) => {
  return (
    <div className="mt-0">
      {!second && (
        <div className="font-weight-bold mb-2">
          خودروی درخواستی را مشخص کنید
        </div>
      )}
      <CarList second  />
    </div>
  );
};

export default CarSelection;
